"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface StatProps {
  value: number;
  suffix: string;
  label: string;
  index: number;
}
function AnimatedNumber({
  value,
  suffix,
  label,
  index
}: StatProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number | null = null;
    const duration = 2000;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easeOut = progress * (2 - progress);
      setCount(Math.floor(easeOut * value));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(value);
      }
    };
    requestAnimationFrame(animate);
  }, [isVisible, value]);
  return <div data-section-id="124366" ref={ref} data-index={index} className="flex flex-col items-center justify-center p-6 text-center group">
      <div className="text-5xl md:text-6xl lg:text-7xl font-default font-bold text-secondary mb-3 tracking-tighter tabular-nums transition-transform duration-500 group-hover:scale-105">
        {count}
        {suffix}
      </div>
      <div className="text-sm md:text-base text-muted-foreground font-default font-semibold uppercase tracking-widest">
        {label}
      </div>
    </div>;
}
export default function OurImpactInNumbers() {
  const stats = [{
    value: 34,
    suffix: "+",
    label: "Years Experience"
  }, {
    value: 2500,
    suffix: "+",
    label: "Decks Installed"
  }, {
    value: 100,
    suffix: "%",
    label: "Licensed & Insured"
  }, {
    value: 4,
    suffix: "",
    label: "Local Experts"
  }];
  return <section id="the-pch-builders-guarantee" className="bg-background text-foreground py-20 md:py-28 relative overflow-hidden border-y border-border">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2317202b' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 divide-x-0 lg:divide-x divide-border/20">
          {stats.map((stat, index) => <AnimatedNumber key={index} index={index} value={stat.value} suffix={stat.suffix} label={stat.label} />)}
        </div>
      </div>
    </section>;
}